/**
 * Utility to remove undefined values from an object.
 *
 * Returns `T` (not `Partial<T>`) because the only fields stripped are
 * those whose value is `undefined` — which can only legitimately happen
 * for optional fields in the input. Required fields must carry a real
 * value at the call site, and the type system already enforces that.
 */
export function removeUndefined<T extends Record<string, unknown>>(obj: T): T {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined)
  ) as T;
}
